import React from 'react';
import PropTypes from 'prop-types';
import objectHash from 'object-hash';
import { StyledTr, StyledTd } from './Table.styles';

const TableBody = ({ rows, columns, doAlternate = true }) => (
  <tbody key={objectHash(columns)}>
    {rows.map((row, i) => (
      <>
        <StyledTr
          data-cy={row.dataCy}
          data-highlighted={row.isHighlighted || undefined}
          key={row.id || row.pax || row.key || i}
          doAlternate={doAlternate}
        >
          {columns.map((column) => (
            <StyledTd key={column.key}>{column.format ? column.format(row[column.key], row) : row[column.key]}</StyledTd>
          ))}
        </StyledTr>
        {row.additionalRows}
      </>
    ))}
  </tbody>
);

TableBody.propTypes = {
  alternateBackground: PropTypes.object,
  doAlternate: PropTypes.bool,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      format: PropTypes.func,
      key: PropTypes.string.isRequired
    }).isRequired
  ).isRequired,
  rows: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired
};

export default TableBody;
